exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block);
};
exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block);
};


//////////////////
// WEBPACK FOOTER
// (webpack)/~/browserify-aes/modes/ecb.js
// module id = 576
// module chunks = 0 3 5